import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { IVendor, IVendorReq, IVendorRes } from '@/interfaces/vendor';
import { AxiosResponse } from 'axios';
import { searchVendors } from '@/adapters/vendor';
import { useCallback, useState } from 'react';
import { debounce } from 'lodash';
// import { twMerge } from 'tailwind-merge';

interface IProps {
  value?: string;
  vendor?: IVendor;
  size?: SizeType;
  isAll?: boolean;
  handleSelectData: (vendor: IVendor) => void;
  readonly?: boolean;
  customClass?: string;
  allowClear?: boolean;
}

const _criteria: IVendorReq = {
  search: '',
};

const VendorSelector = ({
  value,
  size = 'large',
  handleSelectData,
  isAll = false,
  readonly = false,
  vendor,
  customClass,
  allowClear = true,
}: IProps) => {
  const [criteria, setCriteria] = useState<IVendorReq>({ ..._criteria });

  const { data: vendors, isLoading } = useQuery<
    AxiosResponse<IVendorRes>,
    Error
  >({
    queryKey: ['search-vendor', criteria],
    queryFn: async () => await searchVendors(criteria),
  });

  let groupOptions =
    vendors?.data?.data?.map((g) => {
      return {
        value: `${g.VDAD_ID}`,
        label: `${g.VDAD_NAME ?? g.VDAD_ID} (${g.VDAD_ID})`,
      };
    }) || [];

  const allOptions = [{ value: '', label: 'ทั้งหมด' }, ...groupOptions];

  const onChange = (value: string) => {
    const vendorInfo = vendors?.data?.data?.find((d) => d.VDAD_ID === value);
    handleSelectData(vendorInfo as IVendor);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((value) => {
      setCriteria({
        ...criteria,
        search: value,
      });
    }, 300),
    []
  );

  if (vendor) groupOptions = [...groupOptions];
  return (
    <Select
      allowClear={allowClear}
      showSearch
      loading={isLoading}
      value={value}
      className={customClass}
      size={size}
      placeholder="เลือกเจ้าหนี้"
      onChange={(value) => onChange(value)}
      onClear={() => onChange('')}
      onSearch={debouncedSearch}
      options={isAll ? allOptions : [...groupOptions]}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      disabled={readonly}
    />
  );
};

export default VendorSelector;
